import { useFormTyped } from "shared/hooks";

interface FormContactMethod {
  type: "email" | "phone";
  value: string;
  is_primary: boolean;
}

export interface CreateLeadPayload {
  first_name: string;
  last_name: string;
  property_id?: number | null;
  unit_id?: number | null;
  contact_methods: FormContactMethod[];
  attribution: {
    source?: string;
    medium?: string;
    campaign?: string;
  };
}

// const validationSchema = object({
//   first_name: string().required("First name is required"),
//   last_name: string().required("Last name is required"),
//   contact_methods: array()
//     .of(
//       object({
//         type: string().oneOf(["email", "phone"]).required(),
//         value: string(), // Убираем required() - пустые поля не должны быть обязательными
//         is_primary: boolean()
//       })
//     )
//     .test(
//       "at-least-one-contact",
//       "At least one phone number or email is required",
//       function (contactMethods) {
//         return (
//           contactMethods &&
//           contactMethods.some((cm) => cm.value && cm.value.trim() !== "")
//         );
//       }
//     )
// });

export const useFormController = () => {
  const { values, register, handleChange, onSubmit, isSubmitting, reset } =
    useFormTyped<CreateLeadPayload>(
      {
        first_name: "",
        last_name: "",
        attribution: {
          source: "",
          medium: "",
          campaign: ""
        },
        contact_methods: [
          { type: "phone", value: "", is_primary: true },
          { type: "email", value: "", is_primary: true }
        ]
      }
      // validationSchema
    );

  const addContactMethod = (type: "email" | "phone") => {
    const newContactMethods = [
      ...values.contact_methods,
      { type, value: "", is_primary: false }
    ];
    handleChange("contact_methods", () => newContactMethods)();
  };

  const removeContactMethod = (index: number) => {
    const newContactMethods = values.contact_methods.filter(
      (_, i) => i !== index
    );
    handleChange("contact_methods", () => newContactMethods)();
  };

  const updateContactMethod = (index: number, value: string) => {
    const newContactMethods = [...values.contact_methods];
    newContactMethods[index] = { ...newContactMethods[index], value };
    handleChange("contact_methods", () => newContactMethods)();
  };

  const setPropertyId = (id?: number) => {
    handleChange("property_id", () => id)();
  };
  const setUnitId = (id?: number) => {
    handleChange("unit_id", () => id)();
  };

  const setAttribution = (attribution: {
    source?: string;
    medium?: string;
    campaign?: string;
  }) => {
    handleChange("attribution", () => attribution)();
  };

  return {
    values,
    register,
    onSubmit,
    isSubmitting,
    addContactMethod,
    setAttribution,
    removeContactMethod,
    updateContactMethod,
    setPropertyId,
    setUnitId,
    reset
  };
};
